/**
 * Function initiates $.get request to the server and returns the ajax promise
 * It also adds this ajax request to the an object called widgetRequests so that it can be aborted if needed,
 * also, if it's already in the widgetRequests object and it's not resolved, it will not initiate another request, but return the existing one.
 * 1 second after the request is resolved, it will be removed from the widgetRequests object.
 *
 * @param path
 * @param filters
 * @returns {*}
 */
function widgetRequest(path = '', filters =  {}) {
    const widgetRequests = window.widgetRequests = window.widgetRequests || {};

    const filtersWithoutNullishValues = Object.keys(filters).reduce((acc, key) => {
        if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '-1') {
            acc[key] = filters[key];
        }
        return acc;
    }, {});
    const filtersChanged = widgetRequests[path] && JSON.stringify(widgetRequests[path].filters) !== JSON.stringify(filtersWithoutNullishValues);

    if (widgetRequests[path] && !filtersChanged) {
        return widgetRequests[path].request;
    }
    if (widgetRequests[path] && filtersChanged) {
        widgetRequests[path].request.abort();
    }
    widgetRequests[path] = {
        request: jQuery.get(path, filters),
        filters: filtersWithoutNullishValues,
    };

    widgetRequests[path].request.then(() => {
        setTimeout(() => {
            delete widgetRequests[path];
        }, 1000);
    });

    return widgetRequests[path].request;
}